import React from 'react';
import './Legend.css';


export interface LegendItem {
    color: string;
    label: string;
}

const Legend = ({ items }: { items: LegendItem[] }) => {
    return (
        <div className="legend">
            {items.map((item, index) => (
                <div className="legend-item" key={index}>
                    <div className="legend-box" style={{ backgroundColor: item.color }}></div>
                    <span className="legend-text">{item.label}</span>
                </div>
            ))}
        </div>
    );
};

export default Legend;